import React from 'react'

export const PriceComponent = React.memo(({data}) => {
    const { retailPrice, salePrice, pricePreMessage, pricePostMessage } = data
    const nullCheck = (value) => {
        if(!value){
            return true
        }
    }
    const notNullCheck = (value) => {
        if(value){
            return true
        }
    }
    const decimalFormat = amount => {
        return Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2,  maximumFractionDigits: 2 })
      };
    return(<>
            {
                (notNullCheck(retailPrice) && nullCheck(salePrice) && nullCheck(pricePreMessage)) ? 
                    <b className="product-price-font">${decimalFormat(retailPrice)}</b> :
                (notNullCheck(retailPrice) && notNullCheck(salePrice) && nullCheck(pricePreMessage)) ? 
                    <p><s className="product-price-font"><b>${decimalFormat(salePrice)}</b></s>&nbsp;<b className="priceColor product-price-font">${decimalFormat(retailPrice)}</b></p> : 
                (notNullCheck(retailPrice) && notNullCheck(salePrice) && notNullCheck(pricePreMessage)) ? 
                    <p><span className="fontSizeXS">{pricePreMessage}</span>&nbsp;<s className="product-price-font"><b>${decimalFormat(retailPrice)}</b></s>&nbsp;<b className="priceColor product-price-font">${decimalFormat(salePrice)}</b></p> : 
                (notNullCheck(retailPrice) && nullCheck(salePrice) && notNullCheck(pricePreMessage) && notNullCheck(pricePostMessage)) ? 
                    <p><span className="fontSizeXS">{pricePreMessage}</span>&nbsp;<b className="product-price-font">${decimalFormat(retailPrice)}</b>&nbsp;<span className="fontSizeXS">{pricePostMessage}</span></p> :
                (notNullCheck(retailPrice) && nullCheck(salePrice) && notNullCheck(pricePreMessage)) ? 
                    <p><span className="fontSizeXS">{pricePreMessage}</span>&nbsp;<b className="product-price-font">${decimalFormat(retailPrice)}</b></p> :
                null
            }
    </>)
})